import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackViewEventData } from './legacy-types';
import { mapElasticVehicleToLegacyItem } from './utils';

export const createLegacyTrackView = (
  market: Market,
  vehicle: ElasticVehicle,
): LegacyTrackViewEventData => {
  const eventData: LegacyTrackViewEventData = {
    eventType: 'view',
    item: mapElasticVehicleToLegacyItem(market, vehicle),
    pageType: 'product page',
  };

  return eventData;
};

export const useLegacyTrackView = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();

  const trackLegacyView = useCallback(
    (vehicle: ElasticVehicle) => {
      // Track event with only the event-specific data
      // The provider will inject base data (source, url, eventTimestamp, userData)
      track({
        event: 'view',
        data: createLegacyTrackView(market, vehicle),
      });
    },
    [market, track],
  );

  return {
    trackLegacyView,
  };
};
